import { render, staticRenderFns } from "./ClearRealName.vue?vue&type=template&id=4ba4b2fb&scoped=true&"
import script from "./ClearRealName.vue?vue&type=script&lang=js&"
export * from "./ClearRealName.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/dialog.less?vue&type=style&index=0&id=4ba4b2fb&scoped=true&lang=less&"
import style1 from "./ClearRealName.vue?vue&type=style&index=1&id=4ba4b2fb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba4b2fb",
  null
  
)

export default component.exports